import React from 'react';
import PopoverFilter from './shared/PopoverFilter/PopoverFilter';
import FuelTypeFilter from './FuelTypeFilter';
import HullTypeFilter from './HullTypeFilter';
import CapacityFilter from './CapacityFilter';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';

import css from './FeaturesFilter.module.css';

const featuresKeys = ['pub_hullMaterial', 'fuelType', 'pub_passengerCapacity'];

const FeaturesFilter = props => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);
  const numOfFeatures = featuresKeys.filter(key => key in currentQueryParams).length;

  return (
    <PopoverFilter
      label={`${intl.formatMessage({ id: 'General.features' })}${
        numOfFeatures > 0 ? ` (${numOfFeatures})` : ''
      }`}
      {...props}
    >
      <div className={css.root}>
        <FuelTypeFilter variant="drawer" />
        <HullTypeFilter variant="drawer" />
        <CapacityFilter className={css.filter} variant="drawer" />
      </div>
    </PopoverFilter>
  );
};

export default FeaturesFilter;
